import { Theme } from "@amx/ux-twoui-theming";
import { Depths, IButtonStyles, IStackStyles } from "@fluentui/react";
import { highContrastMedia } from "../../styles/media";
import { DrawerBorderRadius } from "./DrawerBase/DrawerBase";

export const getDrawerButtonStyles = (): IButtonStyles => {
    return {
        root: {
            cursor: "pointer",
            position: "relative",
            borderWidth: "0px",
            height: "100%",
            width: "100%",
            padding: "0px",
            [highContrastMedia.active]: {
                borderWidth: "1px",
                ":focus": {
                    outline: "auto"
                }
            }
        }
    };
};

export const getDrawerStyles = (theme: Theme, borderRadius: DrawerBorderRadius, shadow: boolean, showDivider: boolean): IStackStyles => {
    return {
        root: {
            borderRadius,
            overflow: borderRadius !== "0px" ? "hidden" : undefined,
            boxShadow: shadow ? Depths.depth4 : undefined,
            borderBottom: showDivider ? `1px solid ${theme.palette.white}` : undefined,
        }
    };
};
